import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { rem } from '../utilities/style';

import Button from './buttons/Button';
import ButtonDropdown from './buttons/ButtonDropdown';
import ButtonText from './buttons/ButtonText';

const ButtonGroupStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: ${rem(-12)};
  align-items: center;

  ${({ stacked }) => (stacked && `
    flex-direction: column;
  `)};

  ${Button},
  ${ButtonDropdown},
  ${ButtonText} {
    margin: ${rem(12)};
  }
`;

const ButtonGroup = ({ children, stacked = false, className }) => (
  <ButtonGroupStyled stacked={stacked} className={className}>
    {children}
  </ButtonGroupStyled>
);

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  stacked: PropTypes.bool,
  className: PropTypes.string
};

// Convert to styled component so we can reference it in other component styles
export default styled(ButtonGroup)();
